<template>
    <div class="wb-navbar-circle-button"
         v-on:click="$emit('click', $event)"
         :title="tooltip"
         :class="{'wb-navbar-circle-button-disabled': disabled}">
        <slot name="svg"></slot>
    </div>
</template>

<script>
export default {
    name: 'NavbarCircleButton',
    emits: [ 'click' ],
    props: [
        'disabled',
        'tooltip',
    ],
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/animations.scss";

.wb-navbar-circle-button {
    @include wb-c-flex-center;
    color: $darkBlue;
    background-color: $gray2;
    height: 48px;
    width: 48px;
    border-radius: 24px;
    cursor: pointer;
    user-select: none;
    @include button-smooth;
}

.wb-navbar-circle-button:hover {
    background-color: $white;
}

.wb-navbar-circle-button:active {
    color: $green1;
    background-color: $white;
}

.wb-navbar-circle-button-disabled {
    color: $gray3 !important;
    background-color: $gray2 !important;
    cursor: not-allowed !important;
}

</style>
